import React, { useContext } from "react";
import { Content } from "../components/Content";
import { contextApi } from "../context/contextApi";
import { Loading } from "../components/common/Loading";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const Gold = () => {
  const context = useContext(contextApi);
  const { boxes } = useWalletAssets(3);

  return (
    <div className="px-10">
      <Loading show={context.load} />
      <Content boxes={boxes} id={3} pageName="طلا" />
    </div>
  );
};
